import { Deferred } from "../../Helpers/Deferred";
import { GetContractorResponse, ImportContractorsWidgetOptions } from "../Types/ContractorsTypes";

export enum ContractorsActionType {
    ImportViaSidePage = "ContractorsAction.ImportViaSidePage",
    CompleteImport = "ContractorsAction.CompleteImport",
}

export type ContractorsAction =
    | {
          type: ContractorsActionType.ImportViaSidePage;
          payload: {
              deferredResult: Deferred<GetContractorResponse[] | undefined>;
              options: ImportContractorsWidgetOptions;
          };
      }
    | {
          type: ContractorsActionType.CompleteImport;
      };
